import Grid from '@material-ui/core/Grid';
import getYear from 'date-fns/getYear';
import format from 'date-fns/format';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { useArchiveStyles } from '../styles/archives';

interface Video {
    title: string;
    url: string;
    date: string;
}

interface VideoListProps {
    videos: Video[]
}

export const VideoList = (props: VideoListProps) => {
    const { videos } = props;
    const classes = useArchiveStyles();

    return (
        <>
        <Grid container spacing={2}>            
            {videos.length > 0 &&
                videos.map((item: any, index: number) => {
                    const date = new Date(item.date);
                    const year = getYear(date);
                    const month = format(date, 'MMMM');

                    return (
                        <Grid item xs={12} md={4} key={index}>
                            <a href={item.url} target="_blank" rel="noreferrer">
                            <Paper className={classes.paper}>
                                <div className={classes.itemImage}>
                                <img src={`https://lasvegasvp.com/vai/${year}/${month}/${item.title}.jpg`} alt={item.title} style={{ width: '100%' }} />
                                </div>
                
                                <div style={{display: 'flex', justifyContent: 'space-between', padding: '0 15px 15px', marginTop: '-10px' }}>
                                <Typography variant='caption' style={{fontWeight: 'bold', color: 'black'}}>{item.title}</Typography>
                                </div>
                                
                                <div style={{padding: '0 15px 15px 15px'}}>
                                <small style={{color: 'gray'}}>{item.date}</small>
                                </div>
                            </Paper>
                            </a>
                        </Grid>
                    );
                })
            }
        </Grid>
        </>
    )
}

